import React from 'react'
import SectionHead from '../components/SectionHead'
import Wrapper from '../helpers/Wrapper'
import AnimatePage from '../components/AnimatePage'
import { useQuery } from '@tanstack/react-query'
import { apiClient } from '../helpers/Axios'
import { ChangePageTitle } from '../helpers/ChangeTitle'
import ContentLoader from "react-content-loader"
import AccordionTwo from '../components/Accordion/AccordionTwo'

function FAQ() {

    ChangePageTitle("Faq's: Questions with answers")

    const { data, isLoading } = useQuery({
        queryKey: ["faqs"],
        queryFn: async () => {
            const res = await apiClient('/shop/faq')
            return res?.data
        }
    })

    if (isLoading) {
        return (
            <div className="flex items-center justify-center">
                <ContentLoader
                    speed={2}
                    width={476}
                    height={124}
                    viewBox="0 0 476 124"
                    backgroundColor="#f3f3f3"
                    foregroundColor="#ecebeb"
                >
                    <rect x="22" y="19" rx="8" ry="8" width="400" height="40" />
                    <rect x="22" y="19" rx="8" ry="8" width="400" height="40" />
                </ContentLoader>
            </div>

        )
    }


    return (
        <AnimatePage>
            <div className='w-full relative mt-8'>
                <Wrapper>
                    <SectionHead
                        title={"FAQ'S"}
                        description={`Find answers to your questions about orders, shipping, returns, and 
                more in our FAQ section.`}
                    />


                    {/* Questions and Ansers */}
                    <div className="mt-10 w-full mx-auto max-w-3xl ">
                        <div className="w-full">
                            {data && data?.length > 0 && (
                                <div className="w-full flex flex-col gap-4">
                                    {data?.map((faq, i) => (
                                        <AccordionTwo key={i} title={faq?.question}>
                                            <p className="text-gray-500 mt-2 text-[clamp(1rem,2vw+0.8rem,0.9rem)]">
                                                {faq?.answer}
                                            </p>
                                        </AccordionTwo>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </Wrapper>
            </div>
        </AnimatePage>
    )
}

export default FAQ